var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.2 79.2",
    style: {
      enableBackground: "new 0 0 79.2 79.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2A6834;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,79.2c-5.1,0-10.3,0-15.4,0c0-0.2,0-0.3,0-0.5c0-8,0-15.9,0-23.9c0-0.2,0-0.3,0-0.5c0-1.4-0.5-2.5-1.5-3.5 c-1-1-2.2-1.4-3.6-1.4c-3.2,0-6.4,0-9.5,0c-0.2,0-0.4,0-0.5,0c-1.3,0.1-2.4,0.7-3.3,1.7c-0.9,1-1.2,2.1-1.2,3.4c0,8.1,0,16.2,0,24.3 c0,0.1,0,0.3,0,0.4c-5.1,0-10.3,0-15.4,0c-0.1,0-0.3-0.1-0.4-0.1c-2.3-0.4-4-2.5-4-4.9c0-1.3,0-2.6,0-3.9c0-8.4,0-16.8,0-25.2 c0-0.2,0-0.3,0-0.5c-0.2,0-0.3,0-0.5,0c-1,0-2,0-3,0c-0.6,0-1.3,0-1.9,0c-2.3-0.1-4.1-1.7-4.5-4c0-0.1-0.1-0.3-0.1-0.4 c0-0.4,0-0.8,0-1.2c0-0.1,0.1-0.2,0.1-0.3c0.1-0.9,0.6-1.7,1.1-2.4c0.5-0.6,1.1-1.2,1.7-1.8C11.7,25.7,20.5,17,29.2,8.2 c2.1-2.1,4.2-4.2,6.4-6.3c0.4-0.4,0.8-0.8,1.3-1.1c1.8-1.1,3.6-1.1,5.4,0c0.5,0.3,1,0.7,1.4,1.1c1,1,2,1.9,2.9,2.9 c2.5,2.5,5,5,7.5,7.5c0.1,0.1,0.2,0.2,0.3,0.2c0-0.9,0-1.7,0-2.5c0-0.4,0-0.7,0.1-1.1C55,6.8,56.9,5.1,59,5c1.1-0.1,2.2,0,3.3,0 c0.8,0,1.6,0,2.4,0C66,5.1,67,5.5,67.8,6.4c1,1,1.5,2.3,1.5,3.7c0,5.6,0,11.3,0,16.9c0,0.3,0.1,0.6,0.3,0.8c2.2,2.2,4.5,4.4,6.7,6.7 c0.7,0.7,1.3,1.4,1.9,2.1c1,1.2,1.2,2.5,0.9,4c-0.3,1.6-1.2,2.8-2.6,3.5c-0.7,0.4-1.5,0.5-2.4,0.5c-1.4,0-2.9,0-4.3,0 c-0.1,0-0.3,0-0.5,0c0,0.2,0,0.4,0,0.5c0,9.6,0,19.1,0,28.7c0,0.2,0,0.4,0,0.5c-0.1,2.3-1.7,4.3-4,4.8C65.2,79.1,65.1,79.2,65,79.2z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.1adf122851b4b65d3bb4d6771ce45d7e.svg";
export { ForwardRef as ReactComponent };